<div
  *ngIf="
    control && !control.valid && control.errors !== null && control.touched
  "
>
  <ng-container *ngFor="let validationError of control.errors | keyvalue">
    <div [ngSwitch]="validationError.key" class="p-2 !text-orange">
      <ng-container *ngSwitchCase="'required'">
        {{ 'validationError.required' | translate }}
      </ng-container>
      <ng-container *ngSwitchCase="'minlength'">
        {{
          'validationError.minlength'
            | translate: { value: validationError.value['requiredLength'] }
        }}
      </ng-container>
      <ng-container *ngSwitchCase="'maxlength'">
        {{
          'validationError.maxlength'
            | translate: { value: validationError.value['requiredLength'] }
        }}
      </ng-container>
      <ng-container *ngSwitchDefault>
        {{ 'validationError.' + validationError.key | translate }}
      </ng-container>
    </div>
  </ng-container>
</div>
